<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Nazwisko'"
      [data]="beneficiary().nazwisko"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Imię'"
      [data]="beneficiary().imie"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Drugie imię'"
      [data]="beneficiary().drugieImie"
      additionalCssClasses="font-bold"
      additionalCssClassesForTextData="uppercase"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'PESEL'"
      [data]="beneficiary().pesel"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Rodzaj dokumentu'"
      [data]="
        beneficiary().rodzajDokumentu | constLabelReader: DOCUMENT_TYPE_LABELS
      "
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Numer dokumentu'"
      [data]="beneficiary().nrDokumentu"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Obywatelstwo'"
      [data]="beneficiary().obywatelstwo?.nazwa"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Płeć'"
      [data]="beneficiary().plec | constLabelReader: GENDER_LABELS"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Stan cywilny'"
      [data]="
        beneficiary().stanCywilny?.nazwa
          | constLabelReader: MARTIAL_STATUS_LABELS
      "
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
</div>
